<template>
    <div id="res-time-dialog" class="reservation-time dialog" style="display: none">
        <div class="dialog__container">
            <div class="dialog__container--title">新增或刪除時間</div>
            <div class="dialog__container--description" style="color: red">注意預約時間1小時格設定為10:00和10:59</div>
            <form id="time-form" :action="this.url" method="post" v-html="this.insertTextFields(0, this.getConfig)" style="padding: 10px">

            </form>
            <div class="dialog__container--action">
                <button class="mdc-button mdc-button--raised" type="button" v-on:click.prevent="hide">
                    <i class="mdc-button__icon fas fa-times"></i>
                    <span class="mdc-button__label">{{cancelTxt}}</span>
                </button>

                <button class="mdc-button mdc-button--raised" type="submit" form="time-form">
                    <i class="mdc-button__icon fas fa-save"></i>
                    <span class="mdc-button__label">{{saveTxt}}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'url': {
                required: true,
                type: location | String
            }
        },
        computed: {
            defaultConfigs: function () {
                return {
                    start_at: `10:00`,
                    end_at: `10:59`,
                };
            },
            getConfig: function () {
                if (this.config) {
                    return this.config;
                }

                return  this.defaultConfigs;
            },
        },
        data: function () {
            return {
                config: null,
                formCheckFailTxt: '請填好必要資料.',
                saveTxt: '儲存',
                cancelTxt: '取消',
                form: new FormData(),
            }
        },
        methods: {
            insertTextField: function(type, id, title, key, value, materialIcons) {
                return `<div class="config-tf mdc-text-field ${materialIcons ? 'mdc-text-field--with-leading-icon' : '' }" data-mdc-auto-init="MDCTextField">
                            ${ materialIcons ? '<i class="material-icons mdc-text-field__icon">' + `${materialIcons}` +'</i>' : ''}
                            <input type="${type}" ${type === 'number' ? 'step="0.01" max="1"' : ''} id="${id}" name="${key}" class="mdc-text-field__input" value="${value}" required>
                            <label for="${id}" class="mdc-floating-label">${title}</label>
                            <div class="mdc-line-ripple"></div>
                        </div>`;
            },
            insertTextFields: function(index, config) {
                let fields = '';
                for (var key in config) {
                    if (config.hasOwnProperty(key)) {
                        let id = key + "-" + index;
                        let value = config[key];

                        if (key === 'start_at') {
                            let title = "開始時間:";
                            fields += this.insertTextField('time', id, title, key, value, "event")
                        } else if (key === 'end_at') {
                            let title = "預設結束時間:";
                            fields += this.insertTextField('time', id, title, key, value, "event")
                        } else if (key === 'id') {
                            fields += `<input type="hidden" name="id" value="${value}"/>`
                        }
                    }
                }
                return fields;
            },
            formCheck: function() {
                let form = this.form;
                return form.has('start_at') && form.has('end_at');
            },
            show: function() {
                $('#res-time-dialog.dialog').show()
            },
            hide: function() {
                $('#res-time-dialog.dialog').hide();
            },
            deleteEle: function(event, config) {
                console.log(config);
                let element = $(event.currentTarget);
                console.log(element);

                element.parent('.mdc-list-item').remove();
            },
            submit: function () {
                if (!this.formCheck()) {
                    popsale.snackText(this.formCheckFailTxt);
                    return;
                }
                
                popsale.formRequest(this.url, 'post', this.form, function (response) {
                    popsale.snackText('設定成功');
                });
            },
            startEdit: function(store,config) {
                $.ajax({
                    'url': `/system/store/${store}/time_opt/${config}`,
                    method: 'get',
                    success: function (response) {
                        console.log(response);
                        this.config = response;
                        this.show();
                        setTimeout(function () {
                            window.mdc.autoInit();
                        }, 500);
                    }.bind(this)
                });
            }
        },
        mounted() {
            $('button#btn-time-opt.mdc-button').on('click', function () {
                $('div#res-time-dialog.dialog').show();
            });
        }
    }
</script>

<style lang="scss">
    .mdc-list-item__primary-text {
        margin-bottom: 0;

        &--scrollable {
            overflow: auto;
        }
    }

    .config-delete {
        margin-left: 15px;
    }

    .config-tf {
        border-radius: 0;
        width: 50%;
    }
</style>